import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function NoWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    
    // Allow null, undefined, and empty string
    if (value === null || value === undefined || value === '') {
      return null;
    }
    
    // Check for whitespace-only content or "0"
    const stringValue = String(value).trim();
    const isWhitespace = stringValue.length === 0;
    const isZero = stringValue === '0';
    
    return (!isWhitespace && !isZero) ? null : { whitespace: true };
  };
}
